const abTests = {
  homeProofWidget: 'home:proofWidget',
  homeHumbleTeam: 'home:mobile:humbleTeam',

  attentiveModal: 'landing:attentive',
  landingCORBanner: 'landing:CORbanner',
  unsubscribedUserRedirect: 'landing:unsubscribedUserRedirect',
  unsubscribedUserRedirectDesktop: 'landing:unsubscribedUserRedirectDesktop',

  unsubscribeProlonged: 'profile:unsubscribeProlonged',
  unsubscribeOfferTest: 'unsubscribe:offerTest',

  productQuiz: 'product:quiz',

  menuDesktopDropdown: 'menu:desktopDropdown',

  algoliaSearch: 'search:algolia',

  newCancelFlow: 'unsubscribe:firstMonth',

  landingQuizMenu: 'landings:quizMenu',

  zina: 'site:piio',

  queueOrderCOGS: 'site:queueOrderCOGS',

  landingBurgerMenu: 'landing:burgerMenu',
  landingQuizFreeTrial: 'landing:quizFreeTrial',
  newMixPage: 'landing:newMixPage',

  newPaymentFlow: 'site:newPaymentFlow',

  twoItemsOnCo: 'landing:twoItemsCo2',

  acquisitionQuiz: 'site:acquisitionQuiz',
  pickPagePerfumeRating: 'site:pickPagePerfumeRating',

  paymentDesktopShortFlow: 'site:desktopShortFlow',

  newArrivalsProductCards: 'site:newArrivalsProductCards',

  registrationWithTags: 'site:registrationWithTags',

  pickWithNewCards: 'site:pickWithNewCards',

  mainLikeFreeTrial: 'landing:mainLikeFreeTrial2',

  resubscribe50off: 'site:resubscribe50off',

  unsubscriptionFlow: 'site:unsubscriptionFlow2',

  cardUpdate: 'site:cardUpdate',

  newReferralFlow: 'site:newReferralFlow2', // SB-2220

  resubscribeFlow: 'site:resubscribeFlow',
  netflixRecommendations: 'site:netflixRecommendations2', // SB-2009
  referralThxPage: 'site:referralThxPage', // SB-895
  newDesktopMainPage: 'site:newDesktopMainPage', // SB-1942
  emptyQueueTrendingSeason: 'site:emptyQueueTrendingSeason', // SB-2168
}


export default abTests
